import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Main images
import Design from "../assets/Services/Design.png";
import Fabrication from "../assets/Services/Fabrication.png";
import Installation from "../assets/Services/Installation.png";
import Safety from "../assets/Services/Safety.png";
import bg from "../assets/Services/header-service.jpg";

// Sub images
import DesignSub from "../assets/Services/Design-1.png";
import FabricationSub from "../assets/Services/Fabrication-1.png";
import InstallationSub from "../assets/Services/Installation-1.png";
import SafetySub from "../assets/Services/Safety-1.png";

const images = [
  { src: Design, title: "Design" },
  { src: Fabrication, title: "Fabrication" },
  { src: Installation, title: "Installation" },
  { src: Safety, title: "Safety" },
];

const Subimages = [
  { src: DesignSub, title: "Design" },
  { src: FabricationSub, title: "Fabrication" },
  { src: InstallationSub, title: "Installation" },
  { src: SafetySub, title: "Safety" },
];

// Helper hook to get query params
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Services() {
  const query = useQuery();
  const navigate = useNavigate();
  const selectedService = query.get("service");

  const [activeService, setActiveService] = useState(selectedService);

  useEffect(() => {
    if (selectedService) setActiveService(selectedService);
  }, [selectedService]);

  const handleCardClick = (title) => {
    setActiveService(title);
    navigate(`/services?service=${encodeURIComponent(title)}`);
  };

  const selectedSubImage = Subimages.find(img => img.title === activeService);

  return (
    <div style={{
      padding: "12rem",
      minHeight: "100vh",
      backgroundImage: `url(${bg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}>
      <style>{`
        .custom-grid-item.active { background: #13499C; }
        .custom-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        }
        .custom-grid-item {
          border: 1px solid #fff;
          box-shadow: 0 2px 8px rgba(0,0,0,0.07);
          overflow: hidden;
          background: rgba(128,128,128,0.3);
          backdrop-filter: blur(10px);
          text-align: center;
          transition: box-shadow 0.2s, background 0.2s;
          cursor: pointer;
        }
        .custom-grid-image-wrapper { overflow: hidden; }
        .custom-grid-image {
          width: 25%;
          height: 140px;
          object-fit: contain;
          border-radius: 10px;
          margin: 0.5rem auto;
          transition: transform 0.3s cubic-bezier(.4,2,.6,1);
          display: block;
        }
        .custom-grid-item:hover .custom-grid-image { transform: scale(1.2); }
        .custom-grid-title {
          padding: 1rem 0;
          font-weight: 600;
          font-size: 1rem;
          color: #fff;
        }
        /* Responsive grid image height */
        @media (max-width: 600px) {
          .custom-grid-image { height: 100px; }
        }
        /* Responsive sub image card and image */
        .selected-card {
          margin: 2rem auto;
          max-width: 1200px;
          padding: 2rem;
          background: #fff;
          border-radius: 16px;
          text-align: center;
          box-sizing: border-box;
          position: relative;
          overflow: hidden;
        }
        .selected-card img {
          width: 80%;
          max-width: 500px;
          min-width: 220px;
          height: auto;
          min-height: 180px;
          aspect-ratio: 4 / 3;
          border-radius: 12px;
          background: #fff;
          display: block;
          margin: 0 auto;
          object-fit: contain;
        }
        .selected-card-title {
          font-weight: bold;
          font-size: 1.2rem;
          letter-spacing: 1px;
          margin-top: 1rem;
          word-break: break-word;
          overflow-wrap: break-word;
          padding: 0 1rem 1rem 1rem;
          box-sizing: border-box;
        }
        @media (max-width: 600px) {
          .selected-card {
            padding: 0;
            margin: 1rem 0 0 0;
            width: 100vw;
            max-width: 100vw;
            border-radius: 0;
          }
          .selected-card img {
            width: 100vw;
            max-width: 100vw;
            min-width: 0;
            min-height: 250px;
            height: 48vw;
            aspect-ratio: unset;
            border-radius: 0;
            margin: 0 auto;
            display: block;
          }
          .selected-card-title {
            font-size: 1.1rem;
            padding: 0 1rem 1rem 1rem;
            margin-top: 1rem;
          }
        }
      `}</style>

      <div className="custom-grid">
        {images.map((img, idx) => (
          <div
            className={`custom-grid-item${img.title === activeService ? " active" : ""}`}
            key={idx}
            onClick={() => handleCardClick(img.title)}
            style={{ userSelect: "none" }}
          >
            <div className="custom-grid-image-wrapper">
              <img className="custom-grid-image" src={img.src} alt={img.title} />
            </div>
            <div className="custom-grid-title">{img.title}</div>
          </div>
        ))}
      </div>

      {/* Sub image card below */}
      {activeService && selectedSubImage && (
        <div className="selected-card">
          <img
            src={selectedSubImage.src}
            alt={activeService}
          />
          <div className="selected-card-title">
            {activeService}
          </div>
        </div>
      )}
    </div>
  );
}

export default Services;
